import { Button } from '@cad-arc';
import { useDrawerControls } from '../../../../drawers/components/drawer-context-provider';
import { useMapStoreDataForSelfAssignmentModal } from '../../../../fr-event-modals/use-map-store-data-for-self-assignment-modal';
import { FrAssignButton } from '../../../../fr-event-common-components/fr-assign-button';

type EventFooterSectionProps = {
    showManageUnitsButtonInFooter: boolean;
    showAssignSelfButtonInFooter: boolean;
    hasAssignedUnits: boolean;
    entityId?: number;
};

export function EventFooterSection({
    showManageUnitsButtonInFooter,
    showAssignSelfButtonInFooter,
    hasAssignedUnits,
    entityId,
}: EventFooterSectionProps): React.ReactElement {
    const drawerControls = useDrawerControls();
    const { selectedEvent, assignedEvent } = useMapStoreDataForSelfAssignmentModal();

    const handleManageUnits = () => {
        if (entityId) {
            drawerControls.open({
                type: 'manage-units',
                props: {
                    eventId: entityId,
                },
            });
        }
    };

    return (
        <>
            {showManageUnitsButtonInFooter && (
                <Button
                    style={{ width: 'inherit' }}
                    data-testid="MAP_MANAGE_UNITS_BUTTON"
                    onClick={handleManageUnits}
                >
                    Manage Units
                </Button>
            )}
            {showAssignSelfButtonInFooter && (
                <FrAssignButton
                    style={{ width: 'inherit' }}
                    hasAssignedUnits={hasAssignedUnits}
                    selectedEvent={selectedEvent}
                    assignedEvent={assignedEvent}
                />
            )}
        </>
    );
}
